import { Injectable } from '@angular/core';
import { PortalConfigService } from '@tangilla/tg-ng-core';
import { TangillaFormsConfig } from '@tangilla/tg-ng-models';
import { Model } from 'survey-core';

@Injectable({
  providedIn: 'root'
})
export class FormProcessorService {
  constructor(private portalConfigService: PortalConfigService) {
  }

  processFormParameters(surveyModel: Model) {
    const generalFormParameters = (this.portalConfigService
      .portalConfig as TangillaFormsConfig)?.forms_variables.general;

    for (const formParameterKey in generalFormParameters) {
      surveyModel.setVariable(formParameterKey, (generalFormParameters as any)[formParameterKey]);
    }
  }

  processFormPropertiesByType(surveyModel: Model) {
    if ((this.portalConfigService.portalConfig as any)?.forms_properties_by_type) {
      const questions = surveyModel.getAllQuestions();

      const generalFormParameters = (this.portalConfigService
        .portalConfig as any)?.forms_properties_by_type.general;

      for (const formParameterKey in generalFormParameters) {
        const formParameterQuestion = questions.find(q => q['jsonObj'].type === formParameterKey);
        if (formParameterQuestion) {
          formParameterQuestion['jsonObj'] = {
            ...formParameterQuestion['jsonObj'],
            ...generalFormParameters[formParameterKey]
          };
        }
      }
    }
  }
}
